/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

import { withBrandIcon, type BrandIcon } from '../../../icons/with-brand-icon';

const OfficialIcon = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "@atlassian/logo-third-party/servicenow" */ '@atlassian/logo-third-party/servicenow'
		).then((m) => m.ServiceNowIcon),
	{ moduleId: '@atlassian/logo-third-party/servicenow' },
);

const LazyForgeUnitoServicenowProdIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-unito-servicenow-prod" */ './utils').then(
			(m) => m.ForgeUnitoServicenowProdIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-unito-servicenow-prod/icon' },
);

const LazyForgeUnitoServicenowProdSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-unito-servicenow-prod-search-result" */ './utils').then(
			(m) => m.ForgeUnitoServicenowProdSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-unito-servicenow-prod/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const ForgeUnitoServicenowProdIcon: BrandIcon = withBrandIcon(
	(): React.JSX.Element => (
		<Suspense fallback={null}>
			<LazyForgeUnitoServicenowProdIconComponent />
		</Suspense>
	),
	OfficialIcon,
	'small',
);

export const ForgeUnitoServicenowProdSearchResultIcon: BrandIcon = withBrandIcon(
	(): React.JSX.Element => (
		<Suspense fallback={null}>
			<LazyForgeUnitoServicenowProdSearchResultIconComponent />
		</Suspense>
	),
	OfficialIcon,
	'medium',
);
